import * as React from "react";
import type { SVGProps } from "react";
const SvgIconJusticeHammer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <g clipPath="url(#clip0_5894_7681)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.61.85q-.77.14-1.33.64c-.42.38-6.4 6.36-6.54 6.53-.18.25-.36.62-.44.92-.06.21-.07.29-.07.62 0 .32 0 .42.05.6.1.4.25.7.49 1.01.06.08.79.83 1.62 1.66 1.65 1.66 1.69 1.69 2.15 1.88.3.12.53.17.88.19.59.02 1.07-.11 1.57-.45.13-.08.56-.5 1.53-1.45l1.35-1.34 3 3c3.38 3.37 3.09 3.1 3.47 3.1.18 0 .23 0 .36-.06.18-.08.34-.25.43-.43.06-.13.07-.18.06-.35 0-.39.26-.1-3.1-3.47l-3-3 1.3-1.3c.76-.76 1.36-1.37 1.44-1.48.35-.47.52-1.04.5-1.63q-.06-.82-.53-1.45c-.08-.1-.82-.86-1.64-1.69-1.32-1.33-1.52-1.52-1.72-1.65q-.62-.4-1.34-.42-.3-.01-.49.02m.14 1.73c-.2.06.07-.2-4.04 3.88C8.6 8.57 8.08 9.08 8.03 9.19c-.07.12-.07.15-.07.38 0 .22 0 .27.06.38.04.09.38.45 1.47 1.55.78.79 1.46 1.47 1.53 1.52.16.12.29.16.51.16.17 0 .22 0 .36-.07.15-.07.33-.24 3.36-3.26 2.67-2.65 3.22-3.2 3.27-3.31.12-.24.11-.55 0-.79-.06-.1-.38-.44-1.48-1.54-.77-.78-1.44-1.45-1.5-1.49-.18-.16-.54-.22-.8-.14m-11.83 15q-.43.18-.52.66c-.01.1-.02.75-.02 1.7v1.54h-.35c-.58 0-.76.05-.98.27-.47.46-.25 1.26.38 1.42.12.03.91.04 6.18.04 4.3 0 6.08-.01 6.17-.03.35-.07.63-.4.66-.75.03-.39-.19-.75-.54-.88-.12-.05-.2-.06-.59-.07h-.45v-1.56c0-.86 0-1.61-.02-1.69-.04-.27-.23-.52-.48-.64l-.13-.06H7.64l-4.58-.01zm1.18 2.77v1.13h7.04v-2.26H4.1z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_5894_7681">
        <rect width={24} height={24} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgIconJusticeHammer;
